module.exports = "img/flags/BA.252eb01.png";